import "../../style/mobile/home/M_Home.scss";
import MHSearch from "./MH_Search";
import MAmazingOffer from "./M_AmazingOffer";
import Mbanner from "./M_banner";
import MMainSlider from "./M_MainSlider";
import MNewestExams from "./M_NewestExams";

const M_Home = () => {
  return (
    <div className="M-Home">
      <MMainSlider />
      <MHSearch />
      <MAmazingOffer />
      <MNewestExams />
      <Mbanner />
    </div>
  );
};

export default M_Home;
